import { ApiTraveler, ApiTravelerType } from '@ibe/api';

const getGroupedTravelers = (travelers: ApiTraveler[]) => {
  return (
    (travelers &&
      travelers.length &&
      Object.keys(ApiTravelerType).map(travelerType =>
        travelers.filter(traveler => traveler.type === travelerType)
      )) ||
    []
  );
};

export default getGroupedTravelers;
